import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';

export interface UpdateQuestionnaireCutoffResult {
  updateQuestionnaireCutoff: {
    event: {
      id: string;
      questionnaireCutoffAt: string | null;
    };
    ok: boolean;
  };
}

export interface UpdateQuestionnaireCutoffVariables {
  input: {
    eventId: number;
    questionnaireCutoffAt?: string | null;
  };
}

const UpdateQuestionnaireCutoffMutation = gql`
  mutation UpdateQuestionnaireCutoff($input: UpdateQuestionnaireCutoffInput!) {
    updateQuestionnaireCutoff(input: $input) {
      ok
      event {
        id
        questionnaireCutoffAt
      }
    }
  }
`;

export const updateQuestionnaireCutoff = (
  variables: UpdateQuestionnaireCutoffVariables
): Promise<UpdateQuestionnaireCutoffResult> => {
  return gqlClient.request<UpdateQuestionnaireCutoffResult>(
    UpdateQuestionnaireCutoffMutation,
    variables
  );
};
